/**
 * @flow
 */
import React from "react"
import styled from "styled-components"

type Props = {
  active: boolean,
  onSelect: Function,
}

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 2rem;
  width: 100%;

  p {
    margin: 0;
    font-size: 0.9rem;
    line-height: 1.4;
    word-break: break-word;
    a {
      color: var(--havelock-blue);
      &:hover {
        text-decoration: underline;
      }
    }
  }
`

const Box = styled.div`
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  display: inline-block;
  border-radius: 50%;
  border: 2px solid var(--havelock-blue);
  position: relative;
  margin-right: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;

  &:after {
    content: "";
    width: 9px;
    height: 9px;
    background-color: ${props =>
      props.active ? `rgba(80, 125, 220, 1)` : `rgba(80, 125, 220, 0)`};
    transition: 250ms ease-out;
    border-radius: 50%;
  }
  &:hover {
    cursor: pointer;
  }
`

const CheckBoxField = ({ active, onSelect }: Props) => {
  return (
    <Container>
      <Box active={active} onClick={onSelect} />
      <p>
        By signing up with Submitt you agree to our{" "}
        <a href="/terms/" target="_blank" rel="noopener noreferrer">
          terms and conditions
        </a>{" "}
        and{" "}
        <a href="/privacy/" target="_blank" rel="noopener noreferrer">
          privacy policy
        </a>
      </p>
    </Container>
  )
}

CheckBoxField.defaultProps = {
  active: false,
}

export default CheckBoxField
